import axios from 'axios';
import Cookies from 'universal-cookie';
import { NotificationManager } from 'react-notifications';
import { LoginForm } from './Login';

const cookies = new Cookies();

const loginSubmitAdmin = (email, password, remember, dispatch, history) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('password', password);

  return axios.post('https://eps.acces-editions.com/api/loginAppliAdmin', formData)
    .then((response) => {
      const admin = response.data?.data?.[0];
      if (!admin?.email || response.data?.session?.authenticated !== true) {
        NotificationManager.error('E-mail ou mot de passe invalide', '', 3000);
        return;
      }

      cookies.remove('authenticated', { path: '/' });
      cookies.remove('authenticated_admin', { path: '/' });
      cookies.set('authenticated_admin', 'true', remember ? { path: '/', maxAge: 3600 } : { path: '/' });
      cookies.set('statut', admin.statut, { path: '/', maxAge: 3600 });
      dispatch({
        type: 'user/userInfo',
        payload: {id_compte: admin.id_compte, email: admin.email, admin: true, token: response.data.token},
      });
      history.replace('/dashboard');
    })
    .catch(() => {
      NotificationManager.error("La connexion à l'administration a échoué. Veuillez réessayer.", '', 3000);
    });
};

export default function LoginAdmin() {
  return (
    <LoginForm
      loginSubmit={loginSubmitAdmin}
      heading="Connexion administrateur"
      subtitle="Accédez à votre espace d’administration"
      submitLabel="Se connecter"
    />
  );
}
